export const formatNumber = (n: number | null | undefined): string => {
  if (n == null) return '0'
  return new Intl.NumberFormat('pt-BR').format(n)
}

export const formatMonthLabel = (year: number, month: number): string => {
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
  ]
  return `${months[month - 1] ?? '—'}/${year}`
}

export const closeWebview = () => {
  if ('ReactNativeWebView' in window) {
    // @ts-ignore
    window.ReactNativeWebView.postMessage('close')
    return
  }
  if (window.history.length > 1) window.history.back()
}
